import ReactMarkdown from "react-markdown";
import { useNavigate } from "react-router-dom";
import { dynamicResourceLinks, globalUnifiedOptions, jsonParseUTF } from "./util";
import { useContext } from "react";
import { globalContext } from "./App";
import ControlPannel from "./ControlPannel";

function getRenderedBlog(title, content) {
	return (
		<>
			<h1 className="previewh1" style={{fontFamily: "'Lemon/Milk'", textAlign: "center", fontSize: "400%"}}>preview</h1>
			<div className={"blog"}>
				<h1 className="title">{jsonParseUTF(title)}</h1>
				<ReactMarkdown className="content" {...globalUnifiedOptions}>
					{content}
				</ReactMarkdown>
			</div>
		</>
	);
}

const PreviewBlog = () => {
	const navigate = useNavigate();
	const { previewBlog } = useContext(globalContext);

	return (
		<div className="pagebody blogs">
			<div className="mainbody">
				<div className="navpad"></div>
				<ControlPannel >
					<div className="delete flex-jc-cr flex-ai-cr flex-gap10">
					</div>
					<a className="newblog react-router-link right"
						href="blank"
						onClick={(e) => {
							e.preventDefault()
							navigate(-1);
						}}
					>
						<img src={dynamicResourceLinks("ff09ff").undoIcon} alt="" className="icon" />
						<div className="tooltip">
							Go back
						</div>
					</a>
				</ControlPannel>
				<div className="blogscontainer">
					{getRenderedBlog(previewBlog.title, previewBlog.content)}
				</div>
			</div>
		</div>
	);
}

export default PreviewBlog;